import { useCallback, useEffect, useState } from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getFeeDistribution } from 'src/shared/services/feeDistributionService';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { FeeDistributionResponse, FeeDistributionSearchFilter } from '../models/feeDistribution';

/**
 * Hämtar fördelningsunderlaget för en fakturagrupp och en period. Utan fakturagrupp görs inget
 * anrop, eftersom underlaget alltid hör till en fakturagrupp.
 */
export const useFetchFeeDistribution = (searchFilter: FeeDistributionSearchFilter) => {
  const [feeDistribution, setFeeDistribution] = useState<FeeDistributionResponse>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isMounted = useIsMounted();

  const fetchData = useCallback(async () => {
    if (!searchFilter.ownerId || searchFilter.ownerId === 0 || !searchFilter.dateFrom || !searchFilter.dateTo) {
      setFeeDistribution(undefined);
      return;
    }

    setIsLoading(true);

    try {
      const res = await getFeeDistribution(searchFilter);
      if (isMounted() && res) {
        setFeeDistribution(res.data);
      }
    } catch (error) {
      ConsoleHelper.log(error);
      if (isMounted()) {
        setFeeDistribution(undefined);
      }
    } finally {
      if (isMounted()) {
        setIsLoading(false);
      }
    }
  }, [isMounted, searchFilter]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { feeDistribution, isLoading, fetchData };
};
